var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-associates',{staticClass:"table-associate-search",attrs:{"is-associate-id":_vm.isAssociateId,"multiply":_vm.multiply,"value":_vm.associateValue,"placeholder":"Search","data-testid":_vm.dataTestid},on:{"update:value":_vm.updateAssociateFilter}})
}
var staticRenderFns = []

export { render, staticRenderFns }